import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Whitepaper() {
  const { t } = useTranslation();

  return (
    <div className="agu-container">
      <div className="agu-page-header">
        <h1>{t('nav.whitepaper')}</h1>
        <p>AGU의 토큰 이코노미와 설계 철학을 한눈에 정리했습니다.</p>
      </div>

      <section className="agu-section">
        <div className="agu-grid">
          <div className="agu-card">
            <div className="agu-card-title">🧭 AGU 정체성</div>
            <p className="agu-body">
              AGU는 판단에 걸리는 담보이자 검증된 결정만 남기기 위한 최소 신뢰 단위입니다.
            </p>
            <div className="agu-badge">Speculation → Accountability</div>
          </div>
          <div className="agu-card">
            <div className="agu-card-title">🔥 Burn & Sink</div>
            <p className="agu-body">검증 실패, 허위 데이터, Market 붕괴 시 AGU는 소각됩니다.</p>
            <div className="agu-badge">Supply 감소 구조</div>
          </div>
        </div>
      </section>

      <section className="agu-section">
        <div className="agu-panel">
          <div className="agu-panel-header">
            <h2>Core Chapters</h2>
            <p>Whitepaper 핵심 목차를 빠르게 살펴보세요.</p>
          </div>
          <div className="agu-whitepaper-outline">
            <div className="agu-outline-item">
              <h3>Design Philosophy</h3>
              <p>틀린 판단이 구조적으로 비용을 지불하게 만드는 구조</p>
            </div>
            <div className="agu-outline-item">
              <h3>Token Specification</h3>
              <p>총 공급량 1B, 인플레이션 0%, 고정 발행 구조</p>
            </div>
            <div className="agu-outline-item">
              <h3>Utilities</h3>
              <p>Stake / Verification Cost / Reputation Power / Burn & Sink</p>
            </div>
            <div className="agu-outline-item">
              <h3>Revenue Alignment</h3>
              <p>수익 40%가 Buyback & Burn으로 연결</p>
            </div>
          </div>
          <div className="agu-form-actions">
            <button className="agu-button">📘 Download PDF</button>
            <button className="agu-button secondary">🔍 View Full Docs</button>
          </div>
        </div>
      </section>
    </div>
  );
}
